import { useCallback } from "react";
export const useCombineRefs = (...refs) => useCallback((element) => refs.forEach((ref) => {
    if (ref && element) {
        if (typeof ref === "function") {
            ref(element);
        }
        else {
            ref.current = element;
        }
    }
}), refs);
//# sourceMappingURL=useCombineRefs.js.map